module.exports = __webpack_public_path__ + "3d954d05f2a3e4d623c70cecff7483b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/gerichte_inactive.svg
// module id = 28
// module chunks = 0